import ko from "knockout";
import { registerKnockoutExtension } from "flow/knockout/register";

registerKnockoutExtension("nullableNumeric", function (target: any, precision: any) {
    //create a writeable computed observable to intercept writes to our observable
    const result = ko
        .computed({
            read: target,
            write(newValue: any) {
                if (newValue === "" || newValue == null || newValue === 0) {
                    target(null);
                    return;
                }

                const current = target();
                const roundingMultiplier = Math.pow(10, precision);
                const newValueAsNum = isNaN(Number(newValue)) ? 0 : +newValue;
                const valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

                //only write if it changed
                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else {
                    //if the rounded value is the same, but a different value was written, force a notification for the current field
                    if (newValue !== current) {
                        target.notifySubscribers(valueToWrite);
                    }
                }
            }
        })
        .extend({
            notify: "always"
        });

    result(target());
    return result;
});
